import { Checkbox } from "@material-ui/core";
import React, { FC } from "react";
import { displaySettingsAction, SortDirection, SortSettings } from "../../../context/teamQ/reducers/displaySettingsReducer";
import { FilterName, FilterState, FiltersAction } from "../../../context/teamQ/reducers/filtersReducer";
import { useTeamQContext } from "../../../context/teamQContextProvider";
import { useUserContext } from "../../../context/userContextProvider";
import { SavedFilter } from "../../../models";
import { IdLabelDictionary } from "../../../models/staticData";
import { slaStatusOptions, statusOptions } from "./constants";

export type selectOptionsType = { id: string; label: string };
interface Props {
  checkBoxChecked: number | null;
  setCheckBoxChecked: (checkBoxChecked: number | null) => void;
}

const findLabelFromId = (idLabelDictionary: IdLabelDictionary, label: string): string => {
  const entry = Object.entries(idLabelDictionary).find(([, value]) => value === label);
  return entry ? entry[0] : ""; 
}

const getSortFromQueryString = (queryString: string): SortSettings|null => {  
  const searchParams = new URLSearchParams(queryString);
  const sortPair = searchParams.get("orderBy")
  if (sortPair) {
    const [headerToSort, direction] = sortPair.split("|");
    return {
      headerToSort: headerToSort,
      direction: direction as SortDirection,
    };
  }
  return null;
};

export const SavedFilters: FC<Props> = ({ checkBoxChecked, setCheckBoxChecked }) => {
  const {
    state: {
      filters,
      staticData,
    },
    dispatch: { displaySettings: displaySettingsDispatch, filters: filtersDispatch },
  } = useTeamQContext();
  const userContext = useUserContext();
  
  const convertToIdFromLegacyLabel = (filterName: string, filterValue: string): string[] => {
    let name: string = filterName;
    let value: string = filterValue;
    switch (filterName) {
      case "team":
        value = findLabelFromId(staticData.teams, filterValue);
        break;    
      case "classification":
        value = findLabelFromId(staticData.classifications, filterValue);
        break;
      case "groupcode":
        name = "group";
        value = findLabelFromId(staticData.groups, filterValue);
        break;
      case "slastatus":
        value = findLabelFromId(slaStatusOptions, filterValue);
        break;
      case "status":
        value = findLabelFromId(statusOptions, filterValue);
        break;
      default:
        break;
    }
    return [name, value];
  }

  const getFiltersFromQueryString = (filters: FilterState, queryString: string): FilterState => {
    const searchParams = new URLSearchParams(queryString);
    searchParams.get("filterBy")?.split(",").forEach((filterPair: string) => {
      if (filterPair.length > 0) {
        const [filterName, filterValue] = filterPair.split("|");
        const value = decodeURIComponent(filterValue);
        if (["team","classification","groupcode","slastatus","status"].includes(filterName) && isNaN(+value)) {
          const [name, id] = convertToIdFromLegacyLabel(filterName, value);
          filters[name as FilterName].value = id;
        } else {
          filters[filterName as FilterName].value = value;
        }
        filters[filterName as FilterName].show = true;
      }
    });
    return filters;
  };

  return (
    <>
      {userContext.state.savedFilters.length > 0 && <div className="title mt-3">Saved Filters</div>}
      <div className="row">
        {userContext?.state.savedFilters.map((filter: SavedFilter, index: number) => (
          <div className="col-12" key={index}>
            <div className="flex-filters">
              <div className="filter-label">
                <Checkbox
                  checked={checkBoxChecked === index}
                  onClick={(): void => {
                    setCheckBoxChecked(index);
                    filtersDispatch({
                      type: FiltersAction.REPLACE,
                      newFilters: getFiltersFromQueryString(filters, filter.queryString),
                    });
                    const sort = getSortFromQueryString(filter.queryString);
                    if (sort !== null) {
                      displaySettingsDispatch({
                        type: displaySettingsAction.REPLACE_SORT,
                        newSort: sort,
                      });
                    }
                  }}
                />
                {filter.filterName}
              </div>
              <button className="delete-button" onClick={(): void => {
                if (checkBoxChecked === index) setCheckBoxChecked(null);
                userContext.actions.deleteFilter(filter.filterId);
              }}>
                <i className="far fa-trash-alt"></i>
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
